import { Component, OnInit ,Input} from '@angular/core';

import { AuthService } from '../../services/AuthService'
import { BuyService } from '../../services/buyservice'
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Http, Response } from '@angular/http';

import { uploadService } from '../../services/uploadService'
import { Upload } from '../../entities/upload'

@Component({
  selector: 'app-member',
  templateUrl: './member.component.html',
  styleUrls: ['./member.component.css']
})
export class MemberComponent implements OnInit {

  @Input('data') meals: string[] = [];
  page: number = 1;

  dataUser: any = ''
  CreateProfile: FormGroup;
  ampor: any;
  error: any = '';
  email: any = '';
  Data: any;
  DataFull: any[] = [];

  Fullnames: string;

  selectedFiles: FileList;
  currentUpload: Upload;

  historyUser: any[] = [];
  rows: any[] = [];
  private pagetab;

  constructor(public afAut: AuthService, public fb: FormBuilder, private http: Http, public buy: BuyService, public upSvc: uploadService) {

  }
  ngOnInit() {
    this.pagetab = 0;
    let itemHistory = this.buy.gethistory();
    itemHistory.subscribe((snap) => {
      this.historyUser = [];
      for (var i = 0; i < snap.length; i++) {
        if (snap[i].id == this.afAut.email) {
          this.historyUser.push(snap[i])
          
        } 
        //console.log(this.historyUser.length)
      }
      this.rows = Array.from(Array(Math.ceil(this.historyUser.length / 10)).keys())
    })
  }
  detectFiles(event) {
    this.selectedFiles = event.target.files;
    //console.log(this.selectedFiles)
  }
  uploadSingle(id: string) {
     let file = this.selectedFiles.item(0)
    // console.log(id)
     this.currentUpload = new Upload(file);
     this.upSvc.pushUpload(this.currentUpload, id)
  }
  showTabNum(i) {
    this.pagetab = i;
  }
}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/member/member.component.ts